/* global Promise */
import * as R from 'ramda';
import angular from 'angular';

export default function EditFunctionDialogController(
  $scope,
  $rootScope,
  $filter,
  $timeout,
  ssDialogService,
  loaderService,
  alerts,
  emDataService,
  emSharedModelService,
  addFunctionVendorDialog,
  editFunctionDialog,
  addAssetTypeDialog
) {
  const vm = this;

  /**
   * ViewModel definition
   * @typedef {Object} vm
   * @property {string} saveType
   * @property {Object} department
   * @property {Object} process
   * @property {Object} function
   * @property {[]} vendors
   * @property {Object} allVendorsFiltered
   */

  vm.handleCloseDialog = handleCloseDialog;

  vm.handleSubmit = handleSubmit;

  vm.handleAddVendor = handleAddVendor;
  vm.handleFilterTextChange = handleFilterTextChange;
  vm.handleDeletedVendor = _handleDeletedVendor;
  vm.refreshVendors = _refreshVendors;

  vm.handleSelectAllITAssets = _handleSelectAllITAssets;
  vm.handleAddITAssetType = _handleAddITAssetType;

  vm.handleSelectAllNonITAssets = _handleSelectAllNonITAssets;
  vm.handleAddNonITAssetType = _handleAddNonITAssetType;

  vm.handleProcessChange = handleProcessChange;

  vm.dialogIsLoaded = false;
  vm.reloadingVendors = false;

  _activate();

  /** *************************************************
   * Event Handlers
   */

  function handleCloseDialog() {
    _closeDialog();
  }

  function handleAddVendor($event) {
    _showAddVendorDialog($event);
  }

  function handleSubmit($event) {
    if ($scope.emEditFunctionForm.$invalid) {
      return Promise.resolve();
    }
    const isNew = vm.newFunction.functionId < 0;

    loaderService.showViewLoader = true;
    const saveFunctionModel = _getSaveFunctionModel();

    return emSharedModelService.saveFunction(saveFunctionModel).then((savedFunction) => {
      angular.extend(vm.newFunction, savedFunction);
      angular.extend(vm.function, vm.newFunction);
      const processDeptChanged = (vm.newFunction.processId !== vm.originalProcessId || vm.newFunction.departmentId !== vm.originalDeptId)
      if (isNew && vm.addCallback) {
        vm.addCallback(vm.function, processDeptChanged);
      } else if (vm.updateCallback) {
        if(processDeptChanged){
          $rootScope.$broadcast('collapseFunction', { functionId: vm.newFunction.functionId });
        }
        vm.updateCallback(vm.function, processDeptChanged);
      }
      if(!processDeptChanged)
      {
        $rootScope.$broadcast('refreshFunction', { functionId: vm.newFunction.functionId });
      } 
      
      loaderService.showViewLoader = false;
      $scope.emEditFunctionForm.$submitted = false;

      switch (vm.saveType) {
        case 'saveAndAddAnother':
          alerts.success('The function has been saved successfully.');
          _resetForm($event);
          break;
        case 'saveAndClose':
          alerts.success('The function has been saved successfully.');
          _closeDialog();
          break;
        case 'save':
          alerts.success('The function has been saved successfully.');
          break;
        default:
          break;
      }
    })
    .catch(() => {
      alerts.error('An error occurred while saving the Function.');
    })
    .finally(() => {
      loaderService.showViewLoader = false;
    });
  }

  /**
   * Filters the allVendorsFiltered model
   * @param {string} searchString - filter string
   * @return {void}
   */
  function handleFilterTextChange(searchString) {
    vm.vendors = $filter('filter')(vm.newFunction.functionVendors, {
      name: searchString
    });
    vm.allVendorsFiltered = vm.vendors.length === 0;
  }

  function _handleDeletedVendor(vendor) {
    vm.vendors.splice(vm.vendors.indexOf(vendor), 1);
  }

  function handleProcessChange() {
    const ids = vm.selectedProcessDeptId.split("_");
    vm.selectedProcessId = parseInt(ids[0]);
    vm.selectedDeptId = parseInt(ids[1]);
    vm.newFunction.processId = parseInt(ids[0]);
    vm.newFunction.departmentId = parseInt(ids[1]);
    R.forEach((dept) => {   
      if(dept.departmentId === vm.selectedDeptId){
        vm.selectedDepartment = {...dept}
      }
      if (dept.processes && dept.processes.length > 0) {
        const sortedProcesses = R.sortBy(R.prop('name'), dept.processes);
        R.forEach((process) => {
          if(process.processId === vm.selectedProcessId){
            vm.selectedProcess = {...process}
          }
        }, sortedProcesses);
      }
    }, emDataService.departments);
  }

  /** *************************************************
   * Private Functions
   */

  function _activate() {
    vm.newFunction = {
      ...vm.function,
      // Deep copy the arrays of objects...
      functionITAssetTypes: vm.function.functionITAssetTypes.map(obj => ({ ...obj })),
      functionNonITAssetTypes: vm.function.functionNonITAssetTypes.map(obj => ({ ...obj })),
      functionVendors: vm.function.functionVendors.map(obj => ({ ...obj }))
    };
    if (!R.isNil(vm.newFunction)) {
      vm.vendors = vm.newFunction.functionVendors || null;
    }
    vm.allVendorsFiltered = false;
    $timeout(() => { vm.dialogIsLoaded = true; }, 0);

    vm.isAdd = (vm.newFunction.functionId < 0);
    _initEventListeners();
    buildProcessDeptList();
  }

  function buildProcessDeptList() {
    vm.processDeptList = [];
    vm.originalProcessId = vm.process.processId;
    vm.originalDeptId = vm.department.departmentId;
    vm.selectedProcessId = vm.process.processId;
    vm.selectedDeptId = vm.department.departmentId;
    vm.selectedProcess = vm.process;
    vm.selectedDepartment = vm.department;
    vm.selectedProcessDeptId = `${vm.process.processId}_${vm.department.departmentId}`
    vm.newFunction.departmentId = vm.department.departmentId
    R.forEach((dept) => {     
      if (dept.processes && dept.processes.length > 0) {
        const sortedProcesses = R.sortBy(R.prop('name'), dept.processes);
        R.forEach((process) => {
          let combinedProcess = {}
          combinedProcess.name = `${process.name} (${dept.name})`
          combinedProcess.processDeptId = `${process.processId}_${dept.departmentId}`
          vm.processDeptList.push(combinedProcess)
        }, sortedProcesses);
      }
    }, emDataService.departments);
  }

  function _initEventListeners() {
    $scope.$on('refreshFunctionVendor', (event, opt) => {
      let vendorId = null;
      const productIds = [];
      R.forEach((vendorItem) => {
        if (vendorItem.vendorId === opt.vendorId) {
          vendorId = vendorItem.vendorId;
          productIds.push(opt.productId);

          if ((vendorItem.products !== undefined) && (vendorItem.products !== null)) {
            R.forEach((productItem) => {
              if (productItem.isSelected === true) {
                productIds.push(productItem.productId);
              }
            }, vendorItem.products);
          }
        }
      }, vm.vendors);
      vm.vendors = [];
      _refreshVendors(vendorId, productIds);
    });
    $scope.$on('refreshFunctionITAssets', (event, opt) => {
      if (opt.functionId === vm.function.functionId) {
        const customerAssetTypeId = opt.customerAssetTypeId;
        _refreshITAssets(customerAssetTypeId);
      }
    });
    $scope.$on('refreshFunctionNonITAssets', (event, opt) => {
      if (opt.functionId === vm.function.functionId) {
        const customerAssetTypeId = opt.customerAssetTypeId;
        _refreshNonITAssets(customerAssetTypeId);
      }
    });
  }

  function _getSaveFunctionModel() {
    const {
      functionITAssetTypesIds, functionNonITAssetTypesIds, vendorIds, productIds
    } = _getFormSelections();
    return {
      functionId: vm.newFunction.functionId,
      processId: vm.newFunction.processId,
      name: vm.newFunction.name,
      itAssetIds: functionITAssetTypesIds,
      nonITAssetIds: functionNonITAssetTypesIds,
      vendorIds,
      productIds,
    };
  }

  function _resetForm($event) {
    loaderService.showViewLoader = true;
    return _closeDialog().then(() => emSharedModelService.createNewFunction(vm.selectedProcess.processId)
      .then((newFunctionObj) => {
        loaderService.showViewLoader = false;
        vm.allVendorsFiltered = false;
        _showDialog($event, newFunctionObj);
      }));
  }

  function _showDialog($event, functionObj) {
    ssDialogService.dialogs.enterpriseModeling.editFunctionDialog = ssDialogService.alert(
      editFunctionDialog.getOptions($event, {
        customerId: vm.customerId,
        department: vm.selectedDepartment,
        process: vm.selectedProcess,
        functionObj,
        addCallback: null,
        updateCallback: vm.updateCallback,
      })
    );
    return ssDialogService.show(ssDialogService.dialogs.enterpriseModeling.editFunctionDialog);
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.enterpriseModeling.editFunctionDialog);
  }

  function _showAddVendorDialog($event) {
    ssDialogService.dialogs.enterpriseModeling.addFunctionVendorDialog = ssDialogService.alert(
      addFunctionVendorDialog.getOptions($event, {
        vendor: emSharedModelService.createNewVendor({ functionId: vm.newFunction.functionId }),
        addCallback: _handleAddedVendor,
      })
    );
    ssDialogService.show(ssDialogService.dialogs.enterpriseModeling.addFunctionVendorDialog);
  }

  function _handleAddedVendor(addedVendor) {
    /* Blanking out the vendors is necessary as otherwise the new vendor may have an expand arrow even
       when it has no products.  This appears to be because the evaluation in vendor.controller.js
       always runs for the last vendor in the list which may not be the vendor that was added. EM-150. */
    vm.vendors = [];
    return _refreshVendors(addedVendor.vendorId, -1);
  }

  function _refreshVendors(selectedVendorId, selectedProductIds) {
    // vmSharedModelService.refreshVendors();
    loaderService.showViewLoader = true;
    vm.reloadingVendors = true;

    if (vm.newFunction.functionId > 0) {
      vm.vendors = {};
      emSharedModelService.getFunction(vm.newFunction.functionId, true)
        .then((response) => {
          vm.vendors = response.functionVendors;
          if (vm.vendors.length > 1) {
            vm.vendors = emSharedModelService.sortByName(vm.vendors);

            const sortedVendors = [];

            R.forEach((vendorItem) => {
              if ((selectedVendorId !== undefined) && (vendorItem.vendorId === selectedVendorId)) {
                vendorItem.isSelected = true;

                if ((vendorItem.functionProducts !== undefined) && (vendorItem.functionProducts !== null)) {
                  R.forEach((productItem) => {
                    R.forEach((selectedProductId) => {
                      if (productItem.productId === selectedProductId) {
                        productItem.isSelected = true;
                      }
                    }, selectedProductIds);
                  }, vendorItem.functionProducts);
                }
              }

              if (vendorItem.isSelected) {
                sortedVendors.push(vendorItem);
              }
            }, vm.vendors);

            R.forEach((item) => {
              if (!item.isSelected) {
                sortedVendors.push(item);
              }
            }, vm.vendors);

            vm.vendors = sortedVendors;

            if ((vm.newFunction !== undefined) && (vm.newFunction.functionVendors !== undefined)) {
              vm.newFunction.functionVendors = vm.vendors;
            }
            loaderService.showViewLoader = false;
            vm.reloadingVendors = false;
          }
        })
        .catch(() => {
          alerts.error(`An error occurred while retrieving the vendors for function ${vm.newFunction.name}`);
          loaderService.showViewLoader = false;
          vm.reloadingVendors = false;
        });
    } else {
      vm.vendors = {};
      emDataService.getFunction(0)
        .then((response) => {
          vm.vendors = response.data.functionVendors;

          if (vm.vendors.length > 1) {
            vm.vendors = emSharedModelService.sortByName(vm.vendors);

            const sortedVendors = [];

            R.forEach((vendorItem) => {
              if ((selectedVendorId !== undefined) && (vendorItem.vendorId === selectedVendorId)) {
                vendorItem.isSelected = true;

                if ((vendorItem.functionProducts !== undefined) && (vendorItem.functionProducts !== null)) {
                  R.forEach((productItem) => {
                    R.forEach((selectedProductId) => {
                      if (productItem.productId === selectedProductId) {
                        productItem.isSelected = true;
                      }
                    }, selectedProductIds);
                  }, vendorItem.functionProducts);
                }
              }

              if (vendorItem.isSelected) {
                sortedVendors.push(vendorItem);
              }
            }, vm.vendors);

            R.forEach((item) => {
              if (!item.isSelected) {
                sortedVendors.push(item);
              }
            }, vm.vendors);

            vm.vendors = sortedVendors;

            if ((vm.newFunction !== undefined) && (vm.newFunction.functionVendors !== undefined)) {
              vm.newFunction.functionVendors = vm.vendors;
            }
            loaderService.showViewLoader = false;
            vm.reloadingVendors = false;
          }
        })
        .catch(() => {
          alerts.error(`An error occurred while retrieving the IT Assets for function ${vm.newFunction.name}`);
          loaderService.showViewLoader = false;
        });
    }
  }

  function _getFormSelections() {
    const functionITAssetTypes = vm.newFunction.functionITAssetTypes;
    const functionNonITAssetTypes = vm.newFunction.functionNonITAssetTypes;
    const vendors = vm.newFunction.functionVendors;
    const functionITAssetTypesIds = getSelectedIds(functionITAssetTypes, 'customerAssetTypeId');
    const functionNonITAssetTypesIds = getSelectedIds(functionNonITAssetTypes, 'customerAssetTypeId');
    const vendorIds = getSelectedIds(vendors, 'vendorId');
    const productIds = getSelectedChildIds(vendors, 'functionProducts', 'vendorId', 'productId');

    return {
      functionITAssetTypesIds,
      functionNonITAssetTypesIds,
      vendorIds,
      productIds,
    };
  }

  function getSelectedIds(items, propertyName) { // eslint-disable-line no-shadow
    const selectedIds = [];
    R.forEach((item) => {
      if (item.isSelected) {
        selectedIds.push(item[propertyName]);
      }
    }, items);
    return selectedIds;
  }

  function getSelectedChildIds(items, subItemName, parentPropName, childPropName) { // eslint-disable-line no-shadow
    const selectedIds = [];
    R.forEach((item) => {
      R.forEach((subItem) => {
        if (subItem.isSelected) {
          const id = `${item[parentPropName]}-${subItem[childPropName]}`;
          selectedIds.push(id);
        }
      }, item[subItemName]);
    }, items);
    return selectedIds;
  }

  // IT Assets

  function _handleSelectAllITAssets() {
    R.forEach((item) => {
      item.isSelected = vm.ITIsSelected;
    }, vm.newFunction.functionITAssetTypes);
  }

  function _handleAddITAssetType($event) {
    ssDialogService.dialogs.enterpriseModeling.addITAssetTypeDialog = ssDialogService.alert(
      addAssetTypeDialog.getOptions($event, {
        functionId: vm.newFunction.functionId,
        assetType: {
          customerAssetTypeId: -1,
          customerId: vm.customerId,
          masterAssetTypeId: 0,
          assetDataTypeId: 1,
          assetCriticalityId: 5,
          assetDataUseId: 1,
          riskExposure: 2,
          isITAsset: true,
        },
      })
    );
    ssDialogService.show(ssDialogService.dialogs.enterpriseModeling.addITAssetTypeDialog);
  }

  function _refreshITAssets(addedCustomerAssetTypeId) {
    loaderService.showViewLoader = true;

    const selectedCustomerAssetTypeIds = [];
    selectedCustomerAssetTypeIds.push(addedCustomerAssetTypeId);

    // Get the selected items
    R.forEach((item) => {
      if (item.isSelected) {
        selectedCustomerAssetTypeIds.push(item.customerAssetTypeId);
      }
    }, vm.newFunction.functionITAssetTypes);

    if (vm.newFunction.functionId > 0) {
      emSharedModelService.getFunction(vm.newFunction.functionId, true)
        .then((response) => {
          vm.function.functionITAssetTypes = response.functionITAssetTypes;
          vm.newFunction.functionITAssetTypes = response.functionITAssetTypes;

          R.forEach((fita) => {
            R.forEach((scatId) => {
              if ((fita.customerAssetTypeId === scatId) || (fita.customerAssetTypeId === addedCustomerAssetTypeId)) {
                fita.isSelected = true;
              }
            }, selectedCustomerAssetTypeIds);
          }, vm.function.functionITAssetTypes);

          R.forEach((fita) => {
            R.forEach((scatId) => {
              if ((fita.customerAssetTypeId === scatId) || (fita.customerAssetTypeId === addedCustomerAssetTypeId)) {
                fita.isSelected = true;
              }
            }, selectedCustomerAssetTypeIds);
          }, vm.newFunction.functionITAssetTypes);
        })
        .catch(() => {
          alerts.error(`An error occurred while retrieving the IT Assets for function ${vm.newFunction.name}`);
          loaderService.showViewLoader = false;
        });
    } else {
      emDataService.getFunction(0)
        .then((response) => {
          vm.function.functionITAssetTypes = response.data.functionITAssetTypes;
          vm.newFunction.functionITAssetTypes = response.data.functionITAssetTypes;

          R.forEach((fita) => {
            R.forEach((scatId) => {
              if ((fita.customerAssetTypeId === scatId) || (fita.customerAssetTypeId === addedCustomerAssetTypeId)) {
                fita.isSelected = true;
              }
            }, selectedCustomerAssetTypeIds);
          }, vm.function.functionITAssetTypes);

          R.forEach((fita) => {
            R.forEach((scatId) => {
              if ((fita.customerAssetTypeId === scatId) || (fita.customerAssetTypeId === addedCustomerAssetTypeId)) {
                fita.isSelected = true;
              }
            }, selectedCustomerAssetTypeIds);
          }, vm.newFunction.functionITAssetTypes);
        })
        .catch(() => {
          alerts.error(`An error occurred while retrieving the IT Assets for function ${vm.newFunction.name}`);
          loaderService.showViewLoader = false;
        });
    }
  }

  // Non-IT Assets

  function _handleSelectAllNonITAssets() {
    R.forEach((item) => {
      item.isSelected = vm.nonITIsSelected;
    }, vm.newFunction.functionNonITAssetTypes);
  }

  function _handleAddNonITAssetType($event) {
    ssDialogService.dialogs.enterpriseModeling.addITAssetTypeDialog = ssDialogService.alert(
      addAssetTypeDialog.getOptions($event, {
        functionId: vm.newFunction.functionId,
        assetType: {
          customerAssetTypeId: -1,
          customerId: vm.customerId,
          masterAssetTypeId: 0,
          assetDataTypeId: 1,
          assetCriticalityId: 5,
          assetDataUseId: 1,
          riskExposure: 2,
          isITAsset: false,
        },
      })
    );
    ssDialogService.show(ssDialogService.dialogs.enterpriseModeling.addITAssetTypeDialog);
  }

  function _refreshNonITAssets(addedCustomerAssetTypeId) {
    loaderService.showViewLoader = true;
    vm.reloadingVendors = true;

    const selectedCustomerAssetTypeIds = [];
    selectedCustomerAssetTypeIds.push(addedCustomerAssetTypeId);

    // Get the selected items
    R.forEach((item) => {
      if (item.isSelected) {
        selectedCustomerAssetTypeIds.push(item.customerAssetTypeId);
      }
    }, vm.newFunction.functionNonITAssetTypes);

    if (vm.newFunction.functionId > 0) {
      emSharedModelService.getFunction(vm.newFunction.functionId, true).then((response) => {
        vm.function.functionNonITAssetTypes = response.functionNonITAssetTypes;
        vm.newFunction.functionNonITAssetTypes = response.functionNonITAssetTypes;

        R.forEach((fnita) => {
          R.forEach((scatId) => {
            if ((fnita.customerAssetTypeId === scatId) || (fnita.customerAssetTypeId === addedCustomerAssetTypeId)) {
              fnita.isSelected = true;
            }
          }, selectedCustomerAssetTypeIds);
        }, vm.function.functionNonITAssetTypes);

        R.forEach((fnita) => {
          R.forEach((scatId) => {
            if ((fnita.customerAssetTypeId === scatId) || (fnita.customerAssetTypeId === addedCustomerAssetTypeId)) {
              fnita.isSelected = true;
            }
          }, selectedCustomerAssetTypeIds);
        }, vm.newFunction.functionNonITAssetTypes);
      }).catch(() => {
        alerts.error(`An error occurred while retrieving the Non-IT Assets for function ${vm.newFunction.name}`);
        loaderService.showViewLoader = false;
      });
    } else {
      emDataService.getFunction(0)
        .then((response) => {
          vm.function.functionNonITAssetTypes = response.data.functionNonITAssetTypes;
          vm.newFunction.functionNonITAssetTypes = response.data.functionNonITAssetTypes;

          R.forEach((fnita) => {
            R.forEach((scatId) => {
              if ((fnita.customerAssetTypeId === scatId) || (fnita.customerAssetTypeId === addedCustomerAssetTypeId)) {
                fnita.isSelected = true;
              }
            }, selectedCustomerAssetTypeIds);
          }, vm.function.functionNonITAssetTypes);

          R.forEach((fnita) => {
            R.forEach((scatId) => {
              if ((fnita.customerAssetTypeId === scatId) || (fnita.customerAssetTypeId === addedCustomerAssetTypeId)) {
                fnita.isSelected = true;
              }
            }, selectedCustomerAssetTypeIds);
          }, vm.newFunction.functionNonITAssetTypes);
        })
        .catch(() => {
          alerts.error(`An error occurred while retrieving the IT Assets for function ${vm.newFunction.name}`);
          loaderService.showViewLoader = false;
        });
    }
  }
}

EditFunctionDialogController.$inject = [
  '$scope',
  '$rootScope',
  '$filter',
  '$timeout',
  'ssDialogService',
  'loaderService',
  'alerts',
  'emDataService',
  'emSharedModelService',
  'addFunctionVendorDialog',
  'editFunctionDialog',
  'addAssetTypeDialog',
];
